/** Old Reports > CSW list: RSW and CSW reports are one list now (user, 2026-10-16). */
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/reports/csw/")({
  beforeLoad: () => {
    throw redirect({ to: "/reports/warehouse", replace: true });
  },
});
